import { Box, Center, Container } from '@mantine/core';
import type { ReactNode } from 'react';
import starfieldAurora from '@/assets/backgrounds/starfield-navy-aurora.webp';
import { ProductLockup } from './ProductLockup';

/**
 * Shared auth-flow hero (login + verify): the hero product lockup on the
 * brand's *static* starfield photograph under a navy overlay, with the
 * page's card rendered beneath. Deliberately not a synthetic gradient —
 * large soft gradients band on some panels and read as subtle motion.
 */
export function AuthHero({
  width = 420,
  children,
}: Readonly<{ width?: number; children: ReactNode }>) {
  return (
    <Box
      mih="100dvh"
      py={40}
      style={{
        backgroundImage: `linear-gradient(rgba(29, 36, 50, 0.42), rgba(29, 36, 50, 0.62)), url(${starfieldAurora})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: 'var(--mantine-color-navy-8)',
      }}
    >
      <Container size={width}>
        <Center mb={20}>
          <ProductLockup variant="hero" ground="dark" />
        </Center>
        {children}
      </Container>
    </Box>
  );
}
